










































































import {
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    VBTooltip,
} from "bootstrap-vue";
import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
// @ts-ignore
import i18n from "@/libs/i18n";

import TemplateContentHeaderText from "@/views/modules/settings/whatsapp-templates/components/templateContentHeaderText.vue";
import TemplateContentMessage from "@/views/modules/settings/whatsapp-templates/components/templateContentMessage.vue";
import TemplateContentButtonQuickReply from "@/views/modules/settings/whatsapp-templates/components/templateContentButtonQuickReply.vue";
import TemplateContentButtonCtaPhone from "@/views/modules/settings/whatsapp-templates/components/templateContentButtonCtaPhone.vue";
import TemplateContentButtonCtaUrl from "@/views/modules/settings/whatsapp-templates/components/templateContentButtonCtaUrl.vue";
import TemplateContentButtons from "@/views/modules/settings/whatsapp-templates/components/templateContentButtons.vue";
import TemplateContentSamplesModal from "@/views/modules/settings/whatsapp-templates/components/templateContentSamplesModal.vue";
import TemplateAsset from "@/views/modules/settings/whatsapp-templates/components/templateAsset.vue";
import DescriptionInputCounter from "@/views/modules/settings/whatsapp-templates/components/descriptionInputCounter.vue";

import VariablePicker from "@/components/variablePicker.vue";
import { ComponentHeaderType, TemplateInterface } from "@/interfaces/template.interface";
import * as lodash from "lodash";
import useMessageTemplates from "@/composables/useMessageTemplates";
import { ValidationProvider } from "vee-validate";

export default defineComponent({
    components: {
        ValidationProvider,
        BButton,
        BForm,
        BFormSelect,
        BFormInput,
        BFormGroup,
        BCard,
        BCardTitle,
        BCardText,
        BFormTextarea,
        TemplateContentHeaderText,
        TemplateContentMessage,
        TemplateContentButtonQuickReply,
        TemplateContentButtonCtaPhone,
        TemplateContentButtonCtaUrl,
        TemplateContentButtons,
        TemplateContentSamplesModal,
        DescriptionInputCounter,
        TemplateAsset,
        VariablePicker,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    emits: ["is-dirty"],
    props: {
        value: {
            required: true,
            type: Object as PropType<TemplateInterface>,
        },
    },
    setup(props, { emit }) {
        const { headerTypeOptions, buttonTypeOptions } = useMessageTemplates();

        const template = computed<TemplateInterface>({
            get: () => props.value,
            set: (value) => emit("input", value),
        });

        const mediaExamples: Record<ComponentHeaderType, string> = {
            NONE: "",
            TEXT: "",
            [ComponentHeaderType.IMAGE]:
                "https://mfe.saysimple.io/static/files/whatsapp-template-header-examples/image.png",
            [ComponentHeaderType.DOCUMENT]:
                "https://mfe.saysimple.io/static/files/whatsapp-template-header-examples/document.pdf",
            [ComponentHeaderType.VIDEO]:
                "https://mfe.saysimple.io/static/files/whatsapp-template-header-examples/video.mp4",
        };

        const componentHeaderType = computed<ComponentHeaderType>(() => {
            if (template.value.mediaType) {
                return template.value.mediaType.toUpperCase() as ComponentHeaderType;
            }

            if (template.value.components?.header?.type) {
                return ComponentHeaderType.TEXT;
            }

            return ComponentHeaderType.NONE;
        });

        // Set mediaType to default type if it is not yet present
        if (template.value.mediaType && !template.value.components.mediaExamples?.length) {
            template.value.components.mediaExamples = [
                mediaExamples[template.value.mediaType.toUpperCase() as ComponentHeaderType],
            ];
        }

        const changeTemplateHeader = (newHeaderType: ComponentHeaderType) => {
            // Always remove media type if type has changes:
            template.value.assetIsLocked = 0;
            template.value.assetId = 0;

            switch (newHeaderType) {
                case ComponentHeaderType.TEXT:
                    template.value.mediaType = undefined;
                    template.value.components.mediaExamples = undefined;
                    template.value.components.header = {
                        type: "TEXT",
                        text: "",
                    };
                    break;
                case ComponentHeaderType.IMAGE:
                case ComponentHeaderType.DOCUMENT:
                case ComponentHeaderType.VIDEO:
                    template.value.mediaType = newHeaderType.toLocaleLowerCase();
                    template.value.components.mediaExamples = [mediaExamples[newHeaderType]];
                    template.value.components.header = undefined;
                    break;
                default:
                    template.value.mediaType = undefined;
                    template.value.components.mediaExamples = undefined;
                    template.value.components.header = undefined;
                    break;
            }
            forceUpdateTemplate();
        };

        // Set default empty headers by type
        const componentTypeFooterText = computed({
            get: () => template.value.components?.footer?.text ?? "",
            set: (value) => {
                template.value.components.footer = value ? { type: "FOOTER", text: value } : undefined;
                forceUpdateTemplate();
            },
        });

        const forceUpdateTemplate = () => (template.value = lodash.cloneDeep(template.value));

        const templateExamples = computed(() => {
            return template.value.components?.examples ? template.value.components.examples : [];
        });

        return {
            headerTypeOptions,
            buttonTypeOptions,
            template,

            componentHeaderType,
            changeTemplateHeader,

            componentTypeFooterText,
            templateExamples,
        };
    },
});
